// import styles from './InformationFormsStyle.module.scss'
import FormButtons from "./FormButtons";
import React, { useState, useEffect, useContext } from "react";
import { baseUrl } from "../../common/constants";
import { toast } from "react-toastify";
import { mainContext } from "../../context/context";
import axios from "axios";
import AddressField from "../ReusableComponent/AddressField";
import NameField from "../ReusableComponent/NameFields";
import FullAddressField from "../ReusableComponent/FullAddress";
import { formatAddress } from "../ReusableComponent/Common";
import RenderFilesComponent from "../CustomerList/RenderFilesComponent";
import _axios from "../../utils/api/_axios";
import { Content } from "antd/es/layout/layout";
import { Button, Col, Divider, Form, Input, Radio, Row, Select } from "antd";
import { CloudUploadOutlined, EditOutlined } from "@ant-design/icons";
import { getAdminToken } from "../../utils/helpers";
import { useLocation, useParams } from "react-router-dom";
import {
  generateReferredBySchema,
  validateField,
} from "./Validations/FormsValidations";
import { v4 as uuidv4 } from "uuid";
import ViewDocModal from "../../modals/ViewDocModal";
import { formatPhoneNumber } from "../../utils/helpers/phoneFormatter";
import ButtonLoader from "../ReusableElements/Button/ButtonLoader";
import { set } from "react-hook-form";

const { Option } = Select;

const ReferredByForm = ({
  onSubmit,
  handleClose,
  isForm = true,
  patientId = "",
  claim = {},
  docs,
  fetchEmployeeInfo,
  fetchClaims,
  setSelectedClaim,
  companyAndAdjuster
}) => {
  let currentLocation = window.location.pathname;
  let ReferredBySchema = generateReferredBySchema(currentLocation);
  const token = getAdminToken();
  const { id } = useParams();
  const route = `/new-entry/details/${id}`;
  const location = useLocation();
  const [isEditing, setIsEditing] = React.useState(true);
  const [notAssigned, setNotAssigned] = React.useState(false);
  const [scriptId, setScriptId] = useState("");
  const {
    currentTab,
    activeTab,
    getFormData,
    formDataValues,
    getPatientProperties,
    getValuesRefferedForm,
    getValuesRefferedAdjusterId,
    errors,
    setErrors,
  } = useContext(mainContext);
  const [showTextBox, setShowTextBox] = useState(false);
  const [insurenceCompaniesData, setInsurenceCompaniesData] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const [buttonLoaderForSave, setButtonLoaderForSave] = useState();
  const [formValues, setFormValues] = useState({
    referredBy: "",
    referralInfoValue: "",
    adjusterId: "",
    insuranceCompanyId: "",
    insuranceCompanyName: "",
    adjusterName: "",
    adjusters: [],
    insuranceCompanies: [],
    firstName: "",
    lastName: "",
    practiceName: "",
    phone: "",
    email: "",
    fax: "",
    referred_address1: "",
    referred_address2: "",
    referred_city: "",
    referred_state: "",
    referred_zip: "",
    scripts: [],
    insuredPolicyGroupNumber: "",
    otherClaimId: "",
    //isThereAnotherHealthPlan: "",
    reservedNUCC1: "",
    autoAccident: "",
    employmentAccident: "",
    otherAccident: "",
    autoAccidentState: "",
    patientRelationshipToInsured: "",
    reservedNUCC2: "",
    claimCodes: "",
    nurseCaseManager: "",
    ...(token ? null : { adjusterSelectValue: "", insuranceSelectValue: "" }),
  });
  const [insuranceSelectValue, setInsuranceSelectValue] = useState("");
  const [textBoxValue, setTextBoxValue] = useState("");
  const [files, setFiles] = useState([]);
  const [isReportSelected, setIsReportSelected] = useState(false);
  const [scriptValue, setScriptValue] = useState([]);
  const [adjusterSelectValue, setAdjusterSelectValue] = useState("");
  const [insuranceCompanyNameValue, setInsuranceCompanyNameValue] =
    useState("");
  const [adjusterNameValue, setAdjusterNameValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  let {
    firstName,
    lastName,
    practiceName,
    phone,
    email,
    fax,
    referred_address1,
    referred_address2,
    referred_city,
    referred_zip,
    referred_state,
    insuredPolicyGroupNumber,
    otherClaimId,
    claimCodes,
    patientRelationshipToInsured,
    employmentAccident,
    nurseCaseManager,
    autoAccident,
    referredBy,
    otherAccident,
    referralInfoValue,
    scripts,
  } = formValues;
  let referredFormValues = {
    insuranceSelectValue,
    adjusterSelectValue,
    firstName,
    lastName,
    practiceName,
    phone,
    email,
    fax,
    referred_address1,
    referred_address2,
    referred_city,
    referred_zip,
    referred_state,
    insuredPolicyGroupNumber,
    otherClaimId,
    claimCodes,
    patientRelationshipToInsured,
    employmentAccident,
    nurseCaseManager,
    autoAccident,
    referredBy,
    otherAccident,
    referralInfoValue,
    scripts,
  };
  // let selectedFiles = [];
  let scriptUpload = "";

  const adjusterChangeHandler = (value) => {
    if (value === "-1") {
      // open popup to add new adjuster
      return;
    }

    setAdjusterSelectValue(value);
    getValuesRefferedAdjusterId(value);
    const selectedAdjusterId = value;
    const selectedAdjuster = formValues.adjusters.find(
      (adjuster) => adjuster.id === selectedAdjusterId
    );

    const errorMessage = validateField(
      "adjusterSelectValue",
      value,
      ReferredBySchema
    );
    setErrors({ ...errors, ["adjusterSelectValue"]: errorMessage });

    if (selectedAdjuster) {
      const adjusterName = `${selectedAdjuster.firstName} ${selectedAdjuster.lastName}`;
      setAdjusterNameValue(adjusterName);
      setFormValues({
        ...formValues,
        adjusterName: adjusterName,
        adjusterId: selectedAdjusterId,
      });
    } else {
      setFormValues({
        ...formValues,
        adjusterId: selectedAdjusterId,
      });
    }
    getFormData({
      ...formDataValues,
      referredByInfo: {
        ...formDataValues?.referredByInfo,
        adjusterSelectValue:
          selectedAdjuster?.firstName + " " + selectedAdjuster?.lastName,
        ...formDataValues?.referredByInfo,
        adjusterId: selectedAdjusterId,
      },
    });
  };

  const insuranceChangeHandler = (value) => {
    if (value === "-1") {
      // open popup to add new insurance company
      return;
    }
    setInsuranceSelectValue(value);
    getValuesRefferedForm(value);
    setAdjusterSelectValue("");
    getValuesRefferedAdjusterId("");
    const selectedCompanyId = value;
    const selectedInsuranceCompanyName = formValues?.insuranceCompanies?.find(
      (company) => company?.id === selectedCompanyId
    );

    const errorMessage = validateField(
      "insuranceSelectValue",
      value,
      ReferredBySchema
    );
    setErrors({ ...errors, ["insuranceSelectValue"]: errorMessage });

    if (selectedInsuranceCompanyName) {
      setInsuranceCompanyNameValue(selectedInsuranceCompanyName?.companyName || "-1");
      setFormValues({
        ...formValues,
        insuranceCompanyName: selectedInsuranceCompanyName?.companyName
          ? selectedInsuranceCompanyName?.companyName
          : "",
      });
    }

    setFormValues({ ...formValues, insuranceCompanyId: value });

    if (value !== "0") {
      fillAdjusters(value);
    }
    getFormData({
      ...formDataValues,
      referredByInfo: {
        ...formDataValues?.referredByInfo,
        insuranceSelectValue: selectedInsuranceCompanyName?.companyName,
        ...formDataValues?.referredByInfo,
        insuranceCompanyId: selectedCompanyId,
      },
    });
  };

  const [message, setMessage] = useState("");
  const map = (formValues) => {
    return {
      updateProperty: "adjusterInfo",
      value: {
        adjusterType:
          formValues.referredBy == "other"
            ? formValues.referralInfoValue
            : formValues.referredBy,
        adjusterId: formValues.adjusterId || adjusterSelectValue,
        insuranceCompanyId:
          insuranceSelectValue || formValues.insuranceCompanyId,
        referringDoctor: {
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          practiceName: formValues.practiceName,
          phone: formValues.phone,
          email: formValues.email,
          fax: formValues.fax,
          referred_address1: formValues.referred_address1,
          referred_address2: formValues.referred_address2,
          referred_city: formValues.referred_city,
          referred_state: formValues.referred_state,
          referred_zip: formValues.referred_zip,
          nurseCaseManager: formValues.nurseCaseManager,
        },
        insured: {
          insuredPolicyGroupNumber: formValues.insuredPolicyGroupNumber,
          patientRelationshipToInsured: formValues.patientRelationshipToInsured,
          employmentAccident: formValues.employmentAccident,
          autoAccident: formValues.autoAccident,
          autoAccidentState: formValues.autoAccidentState,
          otherAccident: formValues.otherAccident,
          otherClaimId: formValues.otherClaimId,
          // isThereAnotherHealthPlan: formValues.isThereAnotherHealthPlan,
          // reservedNUCC1: formValues.reservedNUCC1,
          // reservedNUCC2: formValues.reservedNUCC2,
          claimCodes: formValues.claimCodes,
        },
        script: scriptUpload,
      },
    };
  };

  const patientSelectChangeHandler = (event) => {
    if (event.target.value === "other") {
      setShowTextBox(true);
      setFormValues({ ...formValues, referredBy: event.target.value });
    } else {
      setShowTextBox(false);
      setFormValues({ ...formValues, referredBy: event.target.value });
    }
  };

  const inputChangeHandler = (event) => {
    const { name, value } = event.target;
    if (event.target.value === "other") {
      setShowTextBox(true);
      setFormValues({ ...formValues, referredBy: event.target.value });
    }
    setFormValues({ ...formValues, [name]: value });
    const errorMessage = validateField(name, value, ReferredBySchema);
    setErrors({ ...errors, [name]: errorMessage });

    getFormData({
      ...formDataValues,
      referredByInfo: {
        ...formDataValues?.referredByInfo,
        [event.target.name]: event.target.value,
      },
    });
  };

  const handlePhoneChange = (e) => {
    const formattedEvent = formatPhoneNumber(e);
    inputChangeHandler(formattedEvent);
  };

  const handleFaxChange = (e) => {
    const formattedEvent = formatPhoneNumber(e);
    inputChangeHandler(formattedEvent);
  };

  const handleFile = (e) => {
    const fileList = e.target.files || e.dataTransfer.files;

    if (fileList.length > 0) {
      const allowedExtensions = [
        ".pdf",
        ".doc",
        ".docx",
        ".jpg",
        ".jpeg",
        ".png",
      ];
      let selectedFiles = [];
      const latestFile = fileList[fileList.length - 1];

      const fileExtension = latestFile.name.split(".").pop();

      if (
        allowedExtensions.includes(`.${fileExtension.toLowerCase()}`) &&
        latestFile.size <= 10 * 1024 * 1024 // 10 MB
      ) {
        const scriptUUID = uuidv4();
        setScriptId(scriptUUID);
        selectedFiles.push(latestFile);
        setFiles(selectedFiles);
        setFormValues({
          ...formValues,
          scripts: [...formValues.scripts, scriptUUID],
        });
        //////////
        getFormData({
          ...formDataValues,
          referredByInfo: {
            ...formDataValues?.referredByInfo,
            scripts: [
              ...(formDataValues?.referredByInfo?.scripts || []),
              scriptUUID,
            ],
          },
        });
        //////////
        setIsReportSelected(true);
      }
      if (selectedFiles.length === 0) {
        toast.error("No valid files selected. Please choose valid files.");
        return;
      }
    }
  };

  const handleFileUpload = async (event) => {
    event.preventDefault();
    setButtonLoaderForSave(true);
    if (
      window.location.pathname === "/open-access-patient" ||
      window.location.pathname === `/new-entry/details/${id}`
    ) {
      if (files.length === 0) {
        toast.error("Please select at least one file to upload.");
        return;
      }
      try {
        const formData = new FormData();
        files.forEach((file) => {
          formData.append("files", file);
        });
        if (window.location.pathname === "/open-access-patient") {
          const url = `${baseUrl}/openAccess/fileUpload/${scriptId}/scripts`;
          const response = await _axios.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (response.status === 201) {
            scriptUpload = response?.data?.payload;
            toast.success("Successfully Uploaded Script.");
            setFiles([]);
          } else {
            toast.error("Upload Failed.");
          }
        } else {
          formData.append("id", id);
          const url = `${baseUrl}/openAccess/fileUpload/${scriptId}/scripts`;
          const response = await _axios.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (response.status === 201) {
            if (window.location.pathname === `/new-entry/details/${id}`) {
              await fetchEmployeeInfo();
            }
            scriptUpload = response?.data?.payload;
            toast.success("Successfully Uploaded Script.");
            setFiles([]);
          } else {
            toast.error("Upload Failed.");
          }
        }

        //TODO pankaj remove this line as per clients demand
        //window.location.reload();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          const errmsg =
            error.response.data?.metadata?.errorMessage ||
            "Duplicate reports. Please upload unique reports.";
          toast.error(errmsg);
        } else {
          toast.error("Error uploading reports.");
        }
      }
    } else {
      let claimId = sessionStorage.getItem("claimId");
      if (!patientId) {
        patientId = sessionStorage.getItem("patientId");
      }
      if (patientId && claim?._id) {
        claimId = claim?._id;
      }
      if (onSubmit) {
        claimId = claim;
      }
      if (patientId && claimId) {
        if (files.length === 0) {
          toast.error("Please select at least one file to upload.");
          return;
        }
        try {
          const formData = new FormData();
          files.forEach((file) => {
            formData.append("files", file);
          });
          const url = `${baseUrl}/patients/${patientId}/claims/${claimId}/upload/scripts`;
          const response = await _axios.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (response.status === 201) {
            scriptUpload = response?.data?.payload;
            toast.success("Successfully Uploaded Script.");
            setFiles([]);
          } else {
            toast.error("Upload Failed.");
          }
          //TODO pankaj remove this line as per clients demand
          //window.location.reload();
        } catch (error) {
          if (error.response && error.response.status === 409) {
            const errmsg =
              error.response.data?.metadata?.errorMessage ||
              "Duplicate reports. Please upload unique reports.";
            toast.error(errmsg);
          } else {
            toast.error("Error uploading reports.");
            console.error("Error:", error);
          }
        }
      } else {
        toast.error("Unable to submit. please select a patient to bind with");
      }
    }
    setButtonLoaderForSave(false);
  };

  const handleScriptDelete = async (file) => {
    if (!file || !file._id) {
      toast.error("Invalid file");
      return;
    }
    let claimId = sessionStorage.getItem("claimId");
    if (!patientId) {
      patientId = sessionStorage.getItem("patientId");
    }
    if (patientId && claim?._id) {
      claimId = claim?._id;
    }
    if (onSubmit) {
      claimId = claim;
    }
    if (patientId && claimId) {
      try {
        const deleteUrl = `${baseUrl}/patients/media/${patientId}/${claimId}/scripts/${file._id}`;

        const updatedFiles = scriptValue.filter((f) => f !== file);
        setScriptValue(updatedFiles);

        await _axios.delete(deleteUrl);
        window.location.reload();

        toast.success(`File ${file.name} deleted successfully.`);
      } catch (error) {
        setScriptValue((prevFiles) => [...prevFiles, file]);

        if (error.response && error.response.status === 404) {
          toast.error("File not found.");
        } else {
          toast.error("Error deleting file.");
        }
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsDisable(true);
    let claimId = sessionStorage.getItem("claimId");
    if (!patientId) {
      patientId = sessionStorage.getItem("patientId");
    }
    const { error } = ReferredBySchema.validate(referredFormValues, {
      abortEarly: false,
    });
    if (error) {
      const errorMessages = error.details.reduce((acc, detail) => {
        acc[detail.path[0]] = detail.message;
        return acc;
      }, {});
      setErrors(errorMessages);
      setIsDisable(false);
    } else {
      setErrors({});

      if (patientId && claim?._id) {
        claimId = claim?._id;
      }
      if (onSubmit) {
        claimId = claim;
      }
      if (patientId && claimId) {
        try {
          let res = await _axios.put(
            `${baseUrl}/patients/${patientId}/claims/${claimId}`,
            map(formValues),
            {
              headers: {
                "Content-Type": "application/json",
              },
              cache: "no-cache",
            }
          );
          let resJson = res.data;
          if (res.status === 200) {
            toast("Successfully saved patient.", {
              type: "success",
              autoClose: 3000,
            });
            setIsDisable(false);
            currentTab(3);
            if (!isForm) {
              setIsEditing(false);
            }
            if (typeof onSubmit === "function") {
              onSubmit();
            }
            if (window.location.pathname === `/patient-info/${id}`) {
              // const response = fetchClaims(patientId);
              // setSelectedClaim(response?.data?.payload?.find(claim => claim._id === claimId))
              window.location.reload();
            }
          } else {
            toast("Unable to submit. Some error occured", {
              type: "error",
              autoClose: 3000,
            });
          }
        } catch (err) {
          toast.error(err?.response?.data?.metadata?.errorMessage);
        }
      } else {
        toast.error("Unable to submit. please select a patient to bind with");
      }
    }
  };

  const setValues = (payload) => {
    let companies = payload?.insuranceCompanies?.message
      ? []
      : payload?.insuranceCompanies;
    setFormValues({
      ...formValues,
      referredBy: payload?.adjusterType || "patient",
      adjusterId: payload?.adjusterId || "",
      insuranceCompanyId: payload?.insuranceCompanyId || "",
      insuranceCompanies: companies || [],
      adjusters: payload?.adjusters || [],
      insuranceCompanyName: payload?.insuranceCompanyName || "",
      adjusterName: payload?.adjusterName || "",
      firstName: payload?.referringDoctor?.firstName || "",
      lastName: payload?.referringDoctor?.lastName || "",
      practiceName: payload?.referringDoctor?.practiceName || "",
      phone: payload?.referringDoctor?.phone || "",
      email: payload?.referringDoctor?.email || "",
      fax: payload?.referringDoctor?.fax || "",
      referred_address1: payload?.referringDoctor?.referred_address1 || "",
      referred_address2: payload?.referringDoctor?.referred_address2 || "",
      referred_city: payload?.referringDoctor?.referred_city || "",
      referred_state: payload?.referringDoctor?.referred_state || "",
      referred_zip: payload?.referringDoctor?.referred_zip || "",
      insuredPolicyGroupNumber:
        payload?.insured?.insuredPolicyGroupNumber || "",
      otherClaimId: payload?.insured?.otherClaimId || "",
      // isThereAnotherHealthPlan: payload?.insured?.isThereAnotherHealthPlan || true,
      patientRelationshipToInsured:
        payload?.insured?.patientRelationshipToInsured || "",
      claimCodes: payload?.insured?.claimCodes || "",
      autoAccident: payload?.insured?.autoAccident || "",
      autoAccidentState: payload?.insured?.autoAccidentState || "",
      otherAccident: payload?.insured?.otherAccident || "",
      employmentAccident: payload?.insured?.employmentAccident || "",
      insuranceSelectValue: payload?.insuranceSelectValue || "",
      adjusterSelectValue: payload?.adjusterSelectValue,
      nurseCaseManager: payload?.referringDoctor?.nurseCaseManager,
    });
    if (payload.adjusterType) {
      let value = ["patient", "doctor", "adjuster"].includes(
        payload.adjusterType
      );
      if (!value) {
        setFormValues((prevState) => ({
          ...prevState,
          referredBy: "other",
          referralInfoValue: payload.adjusterType,
        }));
      }
    }
    if (payload?.insuranceCompanyId) {
      setInsuranceSelectValue(payload.insuranceCompanyId);
    }
    if (payload?.adjusterId) {
      setAdjusterSelectValue(payload.adjusterId);
    }
    if (payload?.script) {
      setScriptValue([payload.script]);
    }
  };

  const setAdjusters = (payload) => {
    setFormValues((prevState) => ({
      ...prevState,
      adjusters: [...payload],
    }));
  };

  const setInsuranceCompanies = (payload) => {
    if(payload){
      let companies = payload?.message ? [] : payload;
      setFormValues((prevState) => ({
        ...prevState,
        insuranceCompanies: [...prevState.insuranceCompanies, ...companies],
      }));
    }
  };
  const getInsuranceCompanies = async () => {
    try {
      let res = await axios(`${baseUrl}/insurance`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      let resJson = res.data;
      let companies = resJson.payload?.message ? [] : resJson?.payload;
      setInsurenceCompaniesData(companies);
      setFormValues({ ...formValues, insuranceCompanies: companies });
      return resJson.payload;
    } catch (err) {
      console.log(err);
    }
  };

  const fillAdjusters = async (companyId) => {
    let adjusters = await getAdjusters(companyId);
    if (adjusters.length) {
      setAdjusters(adjusters);
    } else {
      setAdjusters([]);
    }
  };

  const getAdjusters = async (companyId) => {
    try {
      if(!companyId){
        return [];
      }
      let res = await _axios.get(
        `${baseUrl}/insurance/${companyId}/adjusters`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let resJson = res.data;
      if (res.status === 200) {
        setMessage("Adjusters fetched successfully");
      } else {
        setMessage("Some error occurred");
      }
      return resJson.payload;
    } catch (err) {
      console.log(err);
    }
  };

  const enrichPayload = async (payload) => {
    if (!payload) {
      payload = {};
      setNotAssigned(true);
    }
    payload.insuranceCompanies = await getInsuranceCompanies();
    if (payload.adjusterId && payload.insuranceCompanyId) {
      let adjusters = await getAdjusters(payload.insuranceCompanyId);
      payload.adjusters = adjusters?.length ? adjusters : [];
    }
    return payload;
  };

  let fetchInitial = async (patientId, claim) => {
    // TODO, convert this to redux soon
    if (claim.status === "Unassigned") {
      return;
    }
    let claimId = sessionStorage.getItem("claimId");
    if (!patientId) {
      patientId = sessionStorage.getItem("patientId");
    }
    if (onSubmit) {
      claimId = claim;
    }
    if (patientId && claim?._id) {
      claimId = claim?._id;
      return await enrichPayload(claim.adjusterInfo);
    }
    if (patientId && claimId) {
      try {
        let res = await _axios.get(
          `${baseUrl}/patients/${patientId}/claims/${claimId}`,
          {
            params: {
              title: "adjusterInfo",
            },
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        return await enrichPayload(res.data.payload);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleEditClose = () => {
    if (!isForm) {
      setIsEditing(false);
    }
  };

  useEffect(() => {
    setIsEditing(isForm);
    fetchInitial(patientId, claim).then((payload) => {
      if (payload) {
        setValues(payload);
      }
    });

    getInsuranceCompanies().then((payload) => {
      setInsuranceCompanies(payload);
    });
    if (patientId === "") {
      getInsuranceCompanies()
        .then((payload) => {
          setInsuranceCompanies(payload);
        })
        .catch((error) => {
          console.error("Error fetching companies:", error);
        });
    }
  }, []);

  let fetchRefferByInfo = async (patientId = "") => {
    try {
      const URL =
        window.location.pathname === `/new-entry/details/${id}`
          ? `${baseUrl}/openAccess/${id}`
          : `${baseUrl}/patients/${patientId}`;
      const response = await _axios.get(URL);
      let renderResponse =
        location.pathname === `/new-entry/details/${id}`
          ? response.data?.payload?.referredByInfo
          : response.data?.payload;
      if (response.status === 200) {
        // TODO pankaj, remove all irrelevant set messages and use toast message
        // setMessage("User created successfully");
      } else {
        // setMessage("Some error occured");
      }
      return renderResponse;
    } catch (err) {
      console.log(err);
    }
  };

  const mapAPIDataToFormData = (payload) => {
    return {
      patientId: payload?.patientInfo?._id,
      firstName: payload?.firstName,
      lastName: payload?.lastName,
      phone: payload.phone,
      insuranceSelectValue: token
        ? insuranceSelectValue
        : payload.insuranceSelectValue,
      adjusterSelectValue: token
        ? adjusterSelectValue
        : payload.adjusterSelectValue,
      practiceName: payload.practiceName,
      email: payload.email,
      fax: payload.fax,
      referred_address1: payload.referred_address1,
      referred_address2: payload.referred_address2,
      referred_city: payload.referred_city,
      referred_state: payload.referred_state,
      referred_zip: payload.referred_zip,
      insuredFirstName: payload.insuredLastName,
      insuredLastName: payload.insuredLastName,
      insuredPhone: payload.insuredPhone,
      insuredDateOfBirth: payload.insuredDateOfBirth,
      insuredGender: payload.insuredGender,
      insuredIdNumber: payload.insuredIdNumber,
      insuredPolicyGroupNumber: payload.insuredPolicyGroupNumber,
      insuredAddress1: payload.insuredAddress1,
      insuredAddress2: payload.insuredAddress2,
      insuredCity: payload.insuredCity,
      insuredState: payload.insuredState,
      insuredZip: payload.insuredZip,
      otherClaimId: payload.otherClaimId,
      claimCodes: payload.claimCodes,
      patientRelationshipToInsured: payload.patientRelationshipToInsured,
      employmentAccident: payload.employmentAccident,
      otherAccident: payload.otherAccident,
      autoAccident: payload.autoAccident,
      autoAccidentState: payload.autoAccidentState,
      insuranceCompanies: payload?.insuranceCompanies,
      adjusters: formValues.adjusters,
      nurseCaseManager: payload.nurseCaseManager,
    };
  };

  const setPatientValues = (patientData) => {
    const patient = patientData.patientInfo;
    const formPayload = { ...patient, patientId: patient?.patientInfo?._id };
    setFormValues(mapAPIDataToFormData(formPayload));
  };

  useEffect(() => {
    if (window.location.pathname === route) {
      fetchRefferByInfo(patientId).then((payload) => {
        setPatientValues(payload);
        setAdjusterSelectValue(payload?.adjusterSelectValue);
        setInsuranceSelectValue(payload?.insuranceSelectValue);
      });
      getInsuranceCompanies();
    }
  }, []);
  const handleEdit = () => {
    setIsEditing(true);
  };
  let data =
    window.location.pathname === route
      ? formDataValues?.referredByInfo
      : formValues;

      useEffect(() => {
        if (typeof companyAndAdjuster === "function") {
            companyAndAdjuster({
                adjuster: formValues?.adjusterId,
                adjusters: formValues?.adjusters,
                insuranceCompany: formValues?.insuranceCompanyId,
                insuranceCompanies: formValues?.insuranceCompanies,
            });
        }
      }, [formValues]);
    
  const formsRender = () => {
    return (
      <form
        className={`w-full p-4 mb-8 ${
          isEditing
            ? "bg-gray-100 rounded-lg shadow-md"
            : "bg-white border border-gray-300 rounded-lg"
        } ${onSubmit ? "overflow-y-auto max-h-[500px]" : ""}`}
        onSubmit={handleSubmit}
      >
        <div className="flex justify-between items-center bg-gray-600 text-white p-3 rounded-t-lg">
          <h4 className="text-lg font-semibold">Referred By</h4>
          {!isEditing && (
            <div className="flex items-center space-x-2">
              <div
                className="cursor-pointer text-white hover:text-gray-200"
                onClick={handleEdit}
              >
                <EditOutlined className="text-xl" />
              </div>
            </div>
          )}
        </div>

        <div className="">
          <div className="bg-white p-6 rounded-md shadow-md">
            {isEditing ? (
              <>
                <Row className="gap-4">
                  {token && (
                    <Col xs={24} lg={12} className="space-y-2">
                      <div className="text-lg font-semibold text-gray-700">
                        {token && "Select Insurance Company"}
                      </div>
                      {token && (
                        <Form.Item
                          label="Insurance Company"
                          layout="vertical"
                          id="adjuster-simple-select-label"
                          required
                          validateStatus={
                            errors?.insuranceSelectValue ? "error" : ""
                          }
                          help={errors?.insuranceSelectValue}
                          className="w-full"
                        >
                          <Select
                            labelId="insurance-simple-select-label"
                            id="insurance-simple-select"
                            name="insuranceSelectValue"
                            value={insuranceSelectValue}
                            label="Insurance Company"
                            onChange={insuranceChangeHandler}
                            size="large"
                            className="w-full border-gray-300"
                          >
                            <Option key="0" value="">
                              {data?.insuranceSelectValue
                                ? data?.insuranceSelectValue
                                : "--Select--"}
                            </Option>
                            {formValues?.insuranceCompanies?.map((company) => (
                              <Option key={company?.id} value={company?.id}>
                                {company?.companyName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      )}
                    </Col>
                  )}

                  {!token && (
                    <>
                      <Col xs={24} lg={12} className="space-y-2">
                        <Form.Item
                          label="Enter Insurance Company"
                          layout="vertical"
                          htmlFor="insuranceSelectValue"
                          className="w-full"
                        >
                          <Input
                            size="large"
                            placeholder="Enter insurance company"
                            name="insuranceSelectValue"
                            id="insuranceSelectValue"
                            onChange={(e) => inputChangeHandler(e)}
                            value={data?.insuranceSelectValue || ""}
                            className="w-full border-gray-300"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={12} className="space-y-2">
                        <Form.Item
                          label="Enter Adjuster"
                          layout="vertical"
                          htmlFor="adjusterSelectValue"
                          className="w-full"
                        >
                          <Input
                            size="large"
                            placeholder="Enter Adjuster"
                            name="adjusterSelectValue"
                            id="adjusterSelectValue"
                            onChange={(e) => inputChangeHandler(e)}
                            value={data?.adjusterSelectValue || ""}
                            className="w-full border-gray-300"
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}

                  <Col xs={24} lg={12} className="space-y-2">
                    <div className="text-lg font-semibold text-gray-700">
                      {token && "Assign Adjuster"}
                    </div>
                    {token && (
                      <Form.Item
                        label="Adjuster"
                        layout="vertical"
                        id="adjuster-simple-select-label"
                        required
                        validateStatus={
                          errors?.adjusterSelectValue ? "error" : ""
                        }
                        help={errors?.adjusterSelectValue}
                        className="w-full"
                      >
                        <Select
                          labelId="adjuster-simple-select-label"
                          id="adjuster-simple-select"
                          name="adjusterSelectValue"
                          value={adjusterSelectValue}
                          label="Adjuster"
                          onChange={adjusterChangeHandler}
                          size="large"
                          className="w-full border-gray-300"
                        >
                          <Option key="0" value="">
                            {data.adjusterSelectValue
                              ? data.adjusterSelectValue
                              : "--Select--"}
                          </Option>
                          {formValues?.adjusters?.map((adjuster) => (
                            <Option key={adjuster.id} value={adjuster.id}>
                              {adjuster.firstName} {adjuster.lastName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    )}
                  </Col>
                </Row>

                <br></br>
                <hr></hr>
                <div className="text-lg font-semibold text-gray-700">
                  Referring Doctor
                </div>

                <NameField
                  onChange={(e) => inputChangeHandler(e)}
                  formValues={data}
                  disabled={false}
                  errors={errors}
                />
                <Row
                  gutter={16}
                  className="grid grid-cols-1 md:grid-cols-2 gap-4"
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Practice Name"
                      layout="vertical"
                      className="font-medium text-gray-700"
                      htmlFor="practiceName"
                      required
                      validateStatus={errors?.practiceName ? "error" : ""}
                      help={errors?.practiceName}
                    >
                      <Input
                        size="large"
                        className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="Practice Name"
                        name="practiceName"
                        id="practiceName"
                        onChange={(e) => inputChangeHandler(e)}
                        value={data.practiceName || ""}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Phone"
                      layout="vertical"
                      className="font-medium text-gray-700"
                      htmlFor="phone"
                      required
                      validateStatus={errors?.phone ? "error" : ""}
                      help={errors?.phone}
                    >
                      <Input
                        size="large"
                        className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="Phone"
                        name="phone"
                        id="phone"
                        onChange={handlePhoneChange}
                        value={data.phone || ""}
                        maxLength={12}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  gutter={16}
                  className="grid grid-cols-1 md:grid-cols-2 gap-4"
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Email"
                      layout="vertical"
                      className="font-medium text-gray-700"
                      htmlFor="email"
                      required
                      validateStatus={errors?.email ? "error" : ""}
                      help={errors?.email}
                    >
                      <Input
                        size="large"
                        className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="Email"
                        name="email"
                        id="email"
                        onChange={(e) => inputChangeHandler(e)}
                        value={data.email || ""}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Fax"
                      layout="vertical"
                      className="font-medium text-gray-700"
                      htmlFor="fax"
                    >
                      <Input
                        size="large"
                        className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="Fax"
                        name="fax"
                        id="fax"
                        onChange={(e) => handleFaxChange(e)}
                        value={data.fax || ""}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <FullAddressField
                  onChange={(e) => inputChangeHandler(e)}
                  formValues={data}
                  disabled={false}
                  isForm={true}
                  errors={errors}
                  prefix="referred_"
                />

                <AddressField
                  onChange={(e) => inputChangeHandler(e)}
                  formValues={data}
                  disabled={false}
                  isForm={true}
                  errors={errors}
                  prefix="referred_"
                />

                <Col xs={24} lg={12}>
                  <Form.Item
                    label="Nurse Case Manager"
                    layout="vertical"
                    className="font-medium text-gray-700"
                    htmlFor="nurseCaseManager"
                  >
                    <Input
                      size="large"
                      className="w-full border border-gray-300 p-2 rounded-lg focus:ring-1 focus:ring-blue-500"
                      placeholder="Enter Nurse Case Manager Name"
                      name="nurseCaseManager"
                      id="nurseCaseManager"
                      onChange={(e) => inputChangeHandler(e)}
                      value={data.nurseCaseManager || ""}
                    />
                  </Form.Item>
                </Col>

                <br />
                <div className="font-semibold text-gray-800 text-lg mt-4">
                  SAVE
                </div>

                {docs?.length > 0 && (
                <Row gutter={16} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Col xs={24} lg={12}>
                    {docs?.map((element, index) => {
                      const isPDF = element?.name?.toLowerCase().endsWith('.pdf');
                      return (
                        <div key={index} className="w-24 h-12 flex items-center">
                          <Button
                            className="border border-gray-400 px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-100"
                            onClick={() => {
                              if (isPDF && element?.url) {
                                window.open(element.url, '_blank');
                              } else {
                                setIsModalOpen(true);
                              }
                            }}
                          >
                            {element?.name}
                          </Button>
                          {!isPDF && (
                            <ViewDocModal
                              handleCloseModal={() => setIsModalOpen(false)}
                              isModalOpen={isModalOpen}
                              element={element}
                            />
                          )}
                        </div>
                      );
                    })}
                  </Col>
                </Row>
              )}
                <Row
                  gutter={16}
                  className="grid grid-cols-1 md:grid-cols-2 gap-4"
                >
                  <Col xs={24} lg={12}>
                    <Button
                      onClick={handleButtonClick}
                      className="w-full bg-gray-200 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-300"
                    >
                      {isReportSelected ? (
                        <span>
                          Selected Script:{" "}
                          {files?.map((file) => file.name).join(", ")}
                        </span>
                      ) : (
                        <span>Select Script</span>
                      )}
                    </Button>
                    <input
                      type="file"
                      id="fileInput"
                      accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
                      className="hidden"
                      onChange={handleFile}
                    />
                  </Col>

                  <Col xs={24} lg={12}>
                    <Button
                      icon={<CloudUploadOutlined />}
                      component="label"
                      onClick={handleFileUpload}
                      className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
                    >
                      SAVE
                    </Button>
                  </Col>
                </Row>

                <br></br>
                <hr></hr>
                <div className="text-lg font-semibold text-gray-800 mb-3 pb-2 border-b-2 border-gray-300">
                  Insured's Information
                </div>

                <Row gutter={16} className="mb-4">
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Policy Group or FECA Number"
                      layout="vertical"
                      className="font-medium text-gray-700"
                      htmlFor="insuredPolicyGroupNumber"
                      required
                      validateStatus={
                        errors?.insuredPolicyGroupNumber ? "error" : ""
                      }
                      help={errors?.insuredPolicyGroupNumber}
                    >
                      <Input
                        size="large"
                        className="w-full border-gray-300 rounded-md shadow-sm"
                        placeholder="Insured's Policy Group or FECA Number"
                        name="insuredPolicyGroupNumber"
                        id="insuredPolicyGroupNumber"
                        onChange={(e) => inputChangeHandler(e)}
                        value={data.insuredPolicyGroupNumber}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16} className="mb-4">
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Other Claim Id (Designated By NUCC)"
                      layout="vertical"
                      className="font-medium text-gray-700"
                      htmlFor="otherClaimId"
                      required
                      validateStatus={errors?.otherClaimId ? "error" : ""}
                      help={errors?.otherClaimId}
                    >
                      <Input
                        size="large"
                        className="w-full border-gray-300 rounded-md shadow-sm"
                        placeholder="Other Claim Id"
                        id="otherClaimId"
                        name="otherClaimId"
                        onChange={(e) => inputChangeHandler(e)}
                        value={data?.otherClaimId}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Claim Codes (Designated by NUCC)"
                      layout="vertical"
                      className="font-medium text-gray-700"
                      htmlFor="claimCodes"
                      required
                      validateStatus={errors?.claimCodes ? "error" : ""}
                      help={errors?.claimCodes}
                    >
                      <Input
                        size="large"
                        className="w-full border-gray-300 rounded-md shadow-sm"
                        placeholder="Claim Code"
                        id="claimCodes"
                        name="claimCodes"
                        onChange={(e) => inputChangeHandler(e)}
                        value={data?.claimCodes || ""}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16} className="mb-4">
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Patient Relationship to Insured"
                      layout="vertical"
                      required
                      validateStatus={
                        errors?.patientRelationshipToInsured ? "error" : ""
                      }
                      help={errors?.patientRelationshipToInsured}
                    >
                      <select
                        id="patientRelationshipToInsured"
                        name="patientRelationshipToInsured"
                        value={data.patientRelationshipToInsured}
                        onChange={(e) => inputChangeHandler(e)}
                        size="small"
                        className="w-full border-gray-300 rounded-md shadow-sm p-2"
                      >
                        <option value="">--Select--</option>
                        <option value="self">Self</option>
                        <option value="spouse">Spouse</option>
                        <option value="child">Child</option>
                        <option value="other">Other</option>
                      </select>
                    </Form.Item>
                  </Col>
                </Row>

                <hr className="my-4 border-gray-300" />

                <span className="text-lg font-semibold text-gray-800">
                  Is Patient Condition Related To
                </span>

                <Row gutter={16} className="mb-4">
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="a. Employment"
                      layout="vertical"
                      required
                      validateStatus={errors?.employmentAccident ? "error" : ""}
                      help={errors?.employmentAccident}
                    >
                      <select
                        id="employmentAccident"
                        name="employmentAccident"
                        value={data.employmentAccident}
                        onChange={(e) => inputChangeHandler(e)}
                        className="w-full border-gray-300 rounded-md shadow-sm p-2"
                        size="small"
                      >
                        <option value="">--Select--</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </Form.Item>

                    <Form.Item
                      label="c. Other Accident"
                      layout="vertical"
                      required
                      validateStatus={errors?.otherAccident ? "error" : ""}
                      help={errors?.otherAccident}
                    >
                      <select
                        id="otherAccident"
                        name="otherAccident"
                        value={data.otherAccident}
                        onChange={(e) => inputChangeHandler(e)}
                        className="w-full border-gray-300 rounded-md shadow-sm p-2"
                        size="small"
                      >
                        <option value="">--Select--</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="b. Auto Accident"
                      layout="vertical"
                      required
                      validateStatus={errors?.autoAccident ? "error" : ""}
                      help={errors?.autoAccident}
                    >
                      <select
                        id="autoAccident"
                        name="autoAccident"
                        value={data.autoAccident}
                        onChange={(e) => inputChangeHandler(e)}
                        className="w-full border-gray-300 rounded-md shadow-sm p-2"
                        size="small"
                      >
                        <option value="">--Select--</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </Form.Item>

                    <Col xs={24}>
                      <Form.Item
                        label="Place (State)"
                        layout="vertical"
                        className="font-medium text-gray-700"
                        htmlFor="autoAccidentState"
                        validateStatus={
                          errors?.autoAccidentState ? "error" : ""
                        }
                        help={errors?.autoAccidentState}
                      >
                        <Input
                          key={data.autoAccident}
                          size="large"
                          className="w-full border-gray-300 rounded-md shadow-sm"
                          placeholder="State"
                          id="autoAccidentState"
                          disabled={!(data.autoAccident === "Yes")}
                          name="autoAccidentState"
                          onChange={(e) => inputChangeHandler(e)}
                          value={data?.autoAccidentState}
                        />
                      </Form.Item>
                    </Col>
                  </Col>
                </Row>
                <br></br>
                <hr></hr>
                <br></br>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Submitted By (Radio Buttons) */}
                  <div>
                    <Form.Item
                      label="Submitted by"
                      className="font-medium text-gray-700"
                    >
                      <Radio.Group
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="referredBy"
                        value={data.referredBy}
                        onChange={inputChangeHandler}
                        className="flex flex-wrap gap-4"
                      >
                        <Radio className="text-gray-700" value="patient">
                          Patient
                        </Radio>
                        <Radio className="text-gray-700" value="doctor">
                          Referring Doctor
                        </Radio>
                        <Radio className="text-gray-700" value="adjuster">
                          Adjuster
                        </Radio>
                        <Radio className="text-gray-700" value="other">
                          Other
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>

                  {/* Submitter Information (For Other) */}
                  <div>
                    <Form.Item
                      label="Submitter Information (For Other)"
                      className="font-medium text-gray-700"
                    >
                      <Input
                        className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 disabled:bg-gray-200"
                        size="large"
                        placeholder="Referred By"
                        id="referredBy"
                        name="referralInfoValue"
                        onChange={inputChangeHandler}
                        disabled={!showTextBox}
                        value={data.referralInfoValue}
                      />
                    </Form.Item>
                  </div>
                </div>
              </>
            ) : notAssigned ? (
              <div className="showFormField">Not assigned</div>
            ) : (
              <>
                <div className="showFormField">
                  <span>
                    <b>ReferredBy: </b>
                    {formValues.referredBy == "other"
                      ? formValues.referralInfoValue
                      : formValues.referredBy
                      ? formValues.referredBy
                      : ""}
                  </span>
                </div>
                <div className="showFormField">
                  <div>
                    <b>Insurance Company: </b>
                    {
                      formValues?.insuranceCompanies?.find(
                        (company) => company?.id === insuranceSelectValue
                      )?.companyName
                    }
                  </div>
                </div>
                <div className="showFormField">
                  <div>
                    <b>Adjuster: </b>
                    {formValues?.adjusters?.find(
                      (adjuster) => adjuster?.id === adjusterSelectValue
                    )
                      ? `${
                          formValues.adjusters.find(
                            (adjuster) => adjuster?.id === adjusterSelectValue
                          )?.firstName
                        } ${
                          formValues.adjusters.find(
                            (adjuster) => adjuster?.id === adjusterSelectValue
                          )?.lastName
                        }`
                      : ""}
                  </div>
                </div>
                <br></br>
                <hr />
                <div className="showFormField">
                  <div>
                    <b>Referring Doctor</b>
                  </div>
                  <div>
                    <b>Name: </b>
                    {formValues?.firstName
                      ? `${formValues.firstName} ${formValues.lastName || ""}`
                      : claim?.adjusterInfo?.referringDoctor
                      ? `${
                          claim.adjusterInfo.referringDoctor.firstName || ""
                        } ${claim.adjusterInfo.referringDoctor.lastName || ""}`
                      : ""}
                  </div>

                  <div>
                    <b>Practice Name: </b>{" "}
                    {formValues?.practiceName ||
                      claim?.adjusterInfo?.referringDoctor?.practiceName}
                  </div>
                  <div>
                    <b>Address: </b>
                    {(formValues?.referred_address1 &&
                      formatAddress(
                        formValues?.referred_address1,
                        formValues?.referred_address2,
                        formValues?.referred_city,
                        formValues?.referred_state,
                        formValues?.referred_zip
                      )) ||
                      (claim?.adjusterInfo?.referringDoctor
                        ?.referred_address1 &&
                        formatAddress(
                          claim?.adjusterInfo?.referringDoctor
                            ?.referred_address1,
                          claim?.adjusterInfo?.referringDoctor
                            ?.referred_address2,
                          claim?.adjusterInfo?.referringDoctor?.referred_city,
                          claim?.adjusterInfo?.referringDoctor?.referred_state,
                          claim?.adjusterInfo?.referringDoctor?.referred_zip
                        ))}
                  </div>
                  <div>
                    <b>Email: </b>{" "}
                    {formValues.email ||
                      claim?.adjusterInfo?.referringDoctor?.email}
                  </div>
                  <div>
                    <b>Mobile: </b>{" "}
                    {formValues.phone ||
                      claim?.adjusterInfo?.referringDoctor?.phone}
                  </div>
                  <div>
                    <b>Nurse Case Manager: </b>{" "}
                    {formValues.nurseCaseManager ||
                      claim?.adjusterInfo?.referringDoctor?.nurseCaseManager}
                  </div>
                  <div>
                    <b>Script: </b>
                    <RenderFilesComponent
                      fetchedFiles={scriptValue}
                      onDeleteFile={handleScriptDelete}
                    />
                  </div>
                </div>
                <br></br>
                <hr />
                <div className="showFormField">
                  <div>
                    <b>Insured's Information</b>
                  </div>
                  <div>
                    <b>Insured's Policy Group or FECA number: </b>{" "}
                    {formValues?.insuredPolicyGroupNumber ||
                      claim?.adjusterInfo?.insured?.insuredPolicyGroupNumber}
                  </div>
                  <div>
                    <b>Other Claim Id: </b>{" "}
                    {formValues?.otherClaimId ||
                      claim?.adjusterInfo?.insured?.otherClaimId}
                  </div>
                  {/* <div>
                                            <b>Is There another Health Plan: </b> {formValues?.isThereAnotherHealthPlan}
                                        </div> */}
                  <div>
                    <b>Claim codes: </b>{" "}
                    {formValues?.claimCodes ||
                      claim?.adjusterInfo?.insured?.claimCodes}
                  </div>
                  <div>
                    <b>Insured's Relation to Patient </b>{" "}
                    {formValues?.patientRelationshipToInsured ||
                      claim?.adjusterInfo?.insured
                        ?.patientRelationshipToInsured}
                  </div>
                  <div>
                    <b>employment Accident </b>{" "}
                    {formValues?.employmentAccident ||
                      claim?.adjusterInfo?.insured?.employmentAccident}
                  </div>
                  <div>
                    <b>auto Accident </b>{" "}
                    {formValues?.autoAccident ||
                      claim?.adjusterInfo?.insured?.autoAccident}
                  </div>
                  {claim?.adjusterInfo?.insured?.autoAccidentState?.length >
                    0 && (
                    <div>
                      <b>auto Accident state</b>{" "}
                      {formValues?.autoAccidentState ||
                        claim?.adjusterInfo?.insured?.autoAccidentState}
                    </div>
                  )}
                  <div>
                    <b>other Accident </b>{" "}
                    {formValues?.otherAccident ||
                      claim?.adjusterInfo?.insured?.otherAccident}
                  </div>
                </div>
              </>
            )}
          </div>
          {isEditing ? (
            <div className="">
              <Row gutter={16}>
                <Col xs={24} lg={12}></Col>
                <Col xs={24} lg={12}>
                  <FormButtons
                    handleClose={isForm ? handleClose : handleEditClose}
                    isDisable={isDisable}
                  />
                </Col>
              </Row>
            </div>
          ) : notAssigned ? (
            <></>
          ) : (
            <></>
          )}
        </div>
      </form>
    );
  };

  return (
    <Content className=" rounded-lg shadow-md">
      <>{formsRender()}</>
    </Content>
  );
};

export default ReferredByForm;